
export const DIAGNOSIS_SOURCE = 'diagnosis'

export const FULLY_APPLIED_THRESHOLD = 2
export const MAJOR_DISCREPANCY_TYPE = 0
export const MINOR_DISCREPANCY_TYPE = 1
export const NOT_APPLIED_THRESHOLD = 0
export const NOT_EXISTS_THRESHOLD = -2
export const PARTIALLY_APPLIED_THRESHOLD = 1
export const PASSED_THRESHOLD = 55
export const SUCCESFUL_THRESHOLD = 65
export const SATISFIED_THRESHOLD = 80

export const DIAGNOSIS_STATUS = Object.freeze({
  PENDING: 0,
  IN_PROGRESS: 1,
  ERROR: 2,
  DONE: 3,
})
